export const roundUpToNearestDecimal = (number, decimal) =>
  Math.ceil(number * decimal) / decimal
